<template>
  <nav class="navbar nav-header py-0">
    <div
      class="w-100 d-flex align-items-center justify-content-between justify-content-md-end position-relative"
    >
      <!-- Mobile -->
      <div class="d-flex align-items-center d-lg-none">
        <img
          src="@/core/assets/images/layout/logo-admin.png"
          alt="CRYSTAL"
          class="mr-2"
        />
        <span class="sidebar-title text-white w-50">CRYSTAL</span>
      </div>

      <div class="d-lg-none">
        <button
          type="button"
          class="bg-transparent px-0 border-0"
          @click="toggleMenu(true)"
        >
          <MenuIcon />
        </button>
      </div>

      <UserDropdown :user="user" @logout="logout()" class="d-none d-lg-block" />
    </div>
  </nav>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import { UserDropdown, MenuIcon, LocalStorage } from "wize-admin";
import { SecurityService } from "@/core/services";

export default {
  name: "PageHeader",
  data() {
    return {
      showCart: false,
      categories: [],
      subcategories: [],
    };
  },
  components: {
    UserDropdown,
    MenuIcon
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      business: "app/getBusiness",
      businesses: "app/getBusinesses"
    }),
    websiteUrl: function () {
      return process.env.VUE_APP_WEB_URL;
    },
  },
  methods: {
    ...mapMutations({
      toggleMenu: "app/toggleMenu",
    }),
    async logout() {
      try {
        await this.$store.dispatch("app/loading", true);
        await SecurityService.logout({refreshToken: LocalStorage.getRefreshToken()})
      } catch (error) {
        console.error(error)
      } finally {
        await this.$store.dispatch("app/loading", false);
        this.$store.dispatch("auth/logout").then(() => this.$router.push({name: "login"}));
      }
    },
  },
};
</script>

<style scoped lang="stylus"></style>
